module.exports = __webpack_public_path__ + "img/dangerous_good.a3a25333.png";